/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Ai_Translate_From_HintInputs */

const cs_blog_ai_translate_from_hint = /** @type {(inputs: Blog_Ai_Translate_From_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zkopíruje obsah z jazyka ${i?.locale} do vybraných jazyků níže.`)
};

const en_blog_ai_translate_from_hint = /** @type {(inputs: Blog_Ai_Translate_From_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy content from ${i?.locale} into the languages you select below.`)
};

/**
* | output |
* | --- |
* | "Copy content from {locale} into the languages you select below." |
*
* @param {Blog_Ai_Translate_From_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_translate_from_hint = /** @type {((inputs: Blog_Ai_Translate_From_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Translate_From_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_translate_from_hint(inputs)
	return cs_blog_ai_translate_from_hint(inputs)
});